export const isValidCoordinate = (coord: any): boolean => {
  if (coord === null || coord === undefined) return false;
  if (typeof coord === 'string') {
    const v = coord.trim().toLowerCase();
    if (v === 'nan' || v === '') return false;
    const num = Number(coord);
    return Number.isFinite(num) && !isNaN(num);
  }
  if (typeof coord === 'number') {
    return Number.isFinite(coord) && !isNaN(coord);
  }
  return false;
};

export const sanitizeCoordinate = (coord: any): number => {
  if (!isValidCoordinate(coord)) return NaN;
  return typeof coord === 'string' ? Number(coord) : coord;
};

/**
 * Формирует позицию [lat, lon] для Leaflet, валидируя и конвертируя входные координаты.
 * Возвращает null, если координаты невалидны (в т.ч. строковые 'NaN', null и т.п.).
 */
export const validateAndCreatePosition = (
  lat: any,
  lon: any,
  x: any,
  y: any,
  isGeo: boolean
): [number, number] | null => {
  const sanitizedLat = sanitizeCoordinate(lat);
  const sanitizedLon = sanitizeCoordinate(lon);
  const sanitizedX = sanitizeCoordinate(x);
  const sanitizedY = sanitizeCoordinate(y);

  if (isGeo) {
    if (!Number.isFinite(sanitizedLat) || !Number.isFinite(sanitizedLon)) {
      return null;
    }
    return [sanitizedLat, sanitizedLon];
  } else {
    if (!Number.isFinite(sanitizedX) || !Number.isFinite(sanitizedY)) {
      return null;
    }
    // В негео-режиме ранее использовался порядок [y, x]
    return [sanitizedY, sanitizedX];
  }
};
